import React from "react";
import { Header } from "../Header";

export const Layout = ({ children }) => {
  return (
    <div className="flex flex-col items-center  w-[90%] pt-12 max-w-[500px]">
      <Header />
      {children}
    </div>
  );
};
